import { Link } from "react-router-dom";

import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";

interface CostDisclaimerProps {
  className?: string;
}

export default function CostDisclaimer({ className }: CostDisclaimerProps) {
  return (
    <div
      className={cn(
        "rounded-lg p-3 text-xs leading-relaxed text-gray-700 dark:text-gray-300 space-y-2",
        theme.borders.neubrutalism,
        "bg-gray-50 dark:bg-gray-800/50",
        className
      )}
    >
      <p>
        This full back-catalog cost is an estimate based on the number of existing
        episodes. Actual charges depend on audio duration and content complexity.
      </p>
      <p>
        By confirming the full-history import, you authorize Podwise GPT to charge
        your credits or payment method up to this estimated amount. Back-catalog
        transcription begins immediately and is non-refundable. Future episodes
        are automatically transcribed and billed as they arrive. Choosing Start
        from now skips the historical import and makes older episodes unavailable
        in your library and chat.
      </p>
      <p>
        See our{" "}
        <Link
          to="/terms"
          className={cn("font-semibold hover:underline", theme.text.primaryOrange)}
        >
          Terms of Service
        </Link>{" "}
        for details.
      </p>
    </div>
  );
}
